import { render, staticRenderFns } from "./ShareTabModal.vue?vue&type=template&id=c8d9a866&scoped=true&"
import script from "./ShareTabModal.vue?vue&type=script&lang=js&"
export * from "./ShareTabModal.vue?vue&type=script&lang=js&"
import style0 from "./ShareTabModal.vue?vue&type=style&index=0&id=c8d9a866&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d9a866",
  null
  
)

export default component.exports